import type {
  ForgotPasswordFormState,
  LoginFormState,
  ResetPasswordFormState,
  UpdatePasswordFormState,
} from './auth.types'

export const LOGIN_INITIAL_STATE: LoginFormState = {
  username: '',
  errorMessage: null,
  success: false,
  nextStep: null,
}

export const RESET_PASSWORD_INITIAL_STATE: ResetPasswordFormState = {
  code: '',
  password: '',
  confirmPassword: '',
  errorMessage: null,
  success: false,
}

export const UPDATE_PASSWORD_INITIAL_STATE: UpdatePasswordFormState = {
  password: '',
  confirmPassword: '',
  errorMessage: null,
  success: false,
}

export const FORGOT_PASSWORD_INITIAL_STATE: ForgotPasswordFormState = {
  email: '',
  errorMessage: null,
  success: false,
}
